import React, { useEffect, useRef, useState } from 'react';
import Spinner from "react-bootstrap/Spinner";
import { BehaviourQuestions } from "../pages/BehaviourQuestions";
import { useNavigate } from 'react-router-dom';
import vectorcircle from "../assets/images/vector-circle.svg";
import ShieldQuestion from "../assets/images/sheildWhite.svg";
import AccessTime from "../assets/images/clockWhite.svg";
import Checklist from "../assets/images/ChecklistWhite.svg";
import FileSaveOff from "../assets/images/FilesaveoffWhite.svg";
import McqHeader from '../components/McqHeader';
import arrowleft from "../assets/images/arrow-left.svg";
import arrowright from "../assets/images/arrow-right.svg";
import instructionIcon from "../assets/images/instructionsBlue.svg";
import questionIcon from "../assets/images/questionsBlu.svg";
import closeIcon from "../assets/images/closeIcon.svg";
import editProfileIcon from "../assets/images/editProfileBlue.svg";
import WarningIcon from "../assets/images/WarningAmber.svg";
import { useDispatch, useSelector } from 'react-redux';
import { PostCallWithErrorResponse } from '../api/ApiServices';
import ApiConfig from '../api/ApiConfig';
import { toast } from 'react-toastify';
import { updateData } from '../redux/roundtoSlice';
import CustomButton from '../components/customButton';


export default function Questionanswer1() {
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [submitStatus, setSubmitStatus] = useState('');
    const [compltPercetg, setQuizComltPercentage] = useState(0)
    const roundData = useSelector((state) => state.roundData)
    const [isSavingQuiz, setIssavingQuiz] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [isDone, SetIsDone] = useState(false)
    const dispatch = useDispatch()


    const [loadingForBehaviourQuestions] = useState(false);


    useEffect(() => {

        if (roundData?.isTimeUp) {
            saveData()
            dispatch(updateData({ filed: 'isTimeUp', value: false }))
        }

    }, [roundData?.isTimeUp])


    const saveData = () => {

        let answers = []

        setIssavingQuiz(true)

        SetIsDone(true)

        roundData?.questions?.forEach(ques => {

            let answered = ques?.options.filter((opt, index) => {
                return opt?.iselected
            })
            if (answered?.length > 0) {

                answers.push({
                    "questionId": ques?.questionId,
                    "optionsId": answered[0]?.optionId
                })

            }



        })

        let payload = {
            "quizId": roundData?.quizId,
            "quizName": roundData?.quizName,
            "jobcode": roundData?.code,
            "userId": roundData?.userId,
            questionsAns: answers
        }

        setIsLoading(true)

        PostCallWithErrorResponse(ApiConfig.SUBMIT_QUIZ, payload).then((res) => {

            if (res?.json?.succeded) {

                toast.success(res?.json?.response?.statusMessage)
                dispatch(updateData({ field: 'step', value: 3 }))
                navigate('/LywoApplicationStatus')
            } else {
                toast.error(res?.json?.response?.statusMessage)
            }
            SetIsDone(false)
            setIssavingQuiz(false)
            setIsLoading(false)
        })

    }

    const getAssementDetails = async (code = '', userId = '') => {

        if (roundData?.questions?.length > 0) return

        PostCallWithErrorResponse(ApiConfig.GET_QUIZE_QUESTIONS, {
            jobcode: code ? code : roundData?.code,
            userId: userId ? userId : roundData.userId,
        }).then((res) => {
            if (res?.json?.succeded) {
                dispatch(
                    updateData({
                        field: "questions",
                        value: res?.json?.response?.questions,
                    })
                );
                dispatch(
                    updateData({
                        field: "duration",
                        value: res?.json?.response?.duration,
                    })
                );
                dispatch(
                    updateData({ field: "quizId", value: res?.json?.response?.quizId })
                );

            }

        })

    }


    const nextStep = () => {
        const isValid = attempted == roundData?.questions?.length

        console.log(isValid, roundData?.questions?.length);

        if (!isValid) {
            setSubmitStatus('error');
            setError("Are you sure you want to submit ?");
            setShowSubmitModal(true);
            return;
        }

        saveData()
        setSubmitStatus('success');
        setError("");

    };

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(null);
    const [attempted, setAttempted] = useState(0)

    const questionRefs = useRef([]);


    const [activeSection, setActiveSection] = useState(null);

    const calculateNoOfAttempted = () => {


        const count = roundData.questions?.filter(q =>
            q.options.some(opt => opt.iselected)
        ).length

        dispatch(updateData({ field: 'count', value: count }))
        setAttempted(count)
    }

    useEffect(() => {

        calculateNoOfAttempted()

    }, [roundData?.questions])

    const [activeModal, setActiveModal] = useState(null);

    const [isQuestionsExpanded, setIsQuestionsExpanded] = useState(false);

    const handleIconClick = (section) => {
        if (section === 'top') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else if (section === 'instructions') {
            if (activeModal === 'instructions') {
                // Toggle off if already open
                setActiveModal(null);
            } else {
                setActiveModal('instructions');
                setIsQuestionsExpanded(false);
            }
        } else if (section === 'questions') {
            // setActiveModal('questions');
            setIsQuestionsExpanded(true);
        }
    };

    const handleCloseModal = () => {
        setActiveModal(null);
    };

    const toggleQuestionsModal = () => {
        if (activeModal === 'instructions') return;
        setIsQuestionsExpanded(prev => !prev);
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 640 && activeSection) {
                setActiveSection(null);
                setIsQuestionsExpanded(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [activeSection]);

    useEffect(() => {
        const progressBar = document.getElementById("progressBar");
        let percentage = (roundData?.count / roundData?.questions?.length) * 100
        setQuizComltPercentage(percentage.toFixed(0))
        progressBar.style.width = percentage + "%";
    }, [roundData?.count]);
    const [showSubmitModal, setShowSubmitModal] = useState(false);

    const editProfile = () => {

        dispatch(updateData({ field: 'isEditDetails', value: true }))
        navigate("/JobApplicationProcess", { state: { fromOtherPage: true } })

    }

    return (
        <>
            <McqHeader />
            <div
                className="container-fluid-mcq CompanyName-maindis-mcq"
                id="CompanyName-main"
            >
                <div className="mcq-wrap">
                    <div className="mcq-side-num">
                        <div className="col-12 text-center" style={{ padding: "10px 5px" }}>
                            <p>Attempted</p>
                            <h2>{attempted}/ {roundData?.questions?.length}</h2>
                            <div className="row sidnum-pad ms-0 me-0">
                                {
                                    roundData?.questions?.map((ques, index) => {


                                        const isAnswered = ques?.options?.findIndex((i) => i?.iselected)


                                        return (
                                            <div
                                                key={index}
                                                className="col-6 d-flex justify-content-center p-1"
                                            >
                                                <div
                                                    className={`d-flex justify-content-center mcq-nums
                                                     ${currentQuestionIndex === index ? 'active' : ''}
                                                     ${isAnswered != -1 ? 'answered' : ''}`}

                                                    onClick={() => {
                                                        setCurrentQuestionIndex(index);
                                                        if (questionRefs.current[index]) {
                                                            questionRefs.current[index].scrollIntoView({ behavior: 'smooth', block: 'start' });
                                                        }
                                                    }}
                                                >
                                                    <a
                                                        className={`mcq-nums-link text-center
                                                     ${currentQuestionIndex === index ? 'active' : ''}
                                                     ${isAnswered != -1 ? 'answered' : ''}`}
                                                    >
                                                        {index + 1}
                                                    </a>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>

                    <div className="mcq-cntr-qstn" id="company-centerside">
                        <div className="col-12">
                            <form className="space-y-5 max-w-4xl mx-auto job-description-form">
                                {loadingForBehaviourQuestions ? (
                                    <div className="w-100 text-center">
                                        <Spinner style={{ color: "#444ce7" }} />
                                    </div>
                                ) : (
                                    <>

                                        <BehaviourQuestions

                                            questionRefs={questionRefs}
                                        />


                                    </>
                                )}

                            </form>

                            <CustomButton
                                title='Submit'
                                isLoading={isDone}
                                handleClick={nextStep}
                                className='mcq-submt-mobbtn'
                            />
                        </div>
                    </div>

                    <div
                        className="mcq-rightside"
                        id="company-rightside"
                    >
                        <div className="col-12">
                            <div className="company-rightside-part1">
                                <div className="row align-items-center justify-content-center">
                                    <div className="col d-flex">
                                        <h2>Instructions</h2>
                                        <div className="col-auto ms-3">
                                            <img
                                                src={vectorcircle}
                                                className="vector-img"
                                                alt="Vector"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="qstInnfo">
                                    <div className="inFo-itm">
                                        <img src={ShieldQuestion} className="icon-green-box" alt="" />
                                        <span>{roundData?.questions?.length} Questions</span>
                                    </div>

                                    <div className="inFo-itm">
                                        <img src={AccessTime} className="icon-green-box" alt="" />
                                        <span>{roundData?.duration} Minutes limit</span>
                                    </div>

                                    <div className="inFo-itm">
                                        <img src={Checklist} className="icon-green-box" alt="Thumbs Down" />
                                        <span>Multiple choice questions</span>
                                    </div>

                                    <div className="inFo-itm">
                                        <img src={FileSaveOff} className="icon-red-box" alt="Thumbs Up" />
                                        <span>No Save Allowed</span>
                                    </div>

                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className=" bottom-buttons-mcq company-bottom ">
                <button
                    className="comp-savebtn"
                    onClick={editProfile}
                    style={{ width: "120px", padding: "8px 14px", height: "40px" }}
                >
                    Edit Profile
                </button>
                <CustomButton
                    title="submit"
                    handleClick={nextStep}
                    isLoading={isDone}
                    style={{ width: "120px", padding: "8px 14px", height: "40px" }}
                />

            </div>


            {/* Instructions Modal */}
            {activeModal === 'instructions' && <div className="mcq-modalOverlayBg" onClick={handleCloseModal}></div>}
            <div className={`mcq-slideModal ${activeModal === 'instructions' ? 'open' : ''}`}>
                <div className="mcq-modalContentWrap">
                    <div className='mcq-ModalcloseBtn' onClick={handleCloseModal}>
                        <div style={{ width: "80px", height: "6px", backgroundColor: "#D9DDE3", borderRadius: "10px" }}></div>
                    </div>
                    <div className="mcq-instructions">
                        <div className="qstInnfo">
                            <h4 style={{ color: "#3a4b68" }}>Instructions</h4>
                            <div className="inFo-itm">
                                <img src={ShieldQuestion} className="icon-green-box" alt="" />
                                <span>{roundData?.questions?.length} Questions</span>
                            </div>
                            <div className="inFo-itm">
                                <img src={AccessTime} className="icon-green-box" alt="" />
                                <span>{roundData?.duration} Minutes limit</span>
                            </div>
                            <div className="inFo-itm">
                                <img src={Checklist} className="icon-green-box" alt="Thumbs Down" />
                                <span>Multiple choice questions</span>
                            </div>
                            <div className="inFo-itm">
                                <img src={FileSaveOff} className="icon-red-box" alt="Thumbs Up" />
                                <span>No Save Allowed</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Questions Modal */}
            {/* {activeModal === 'questions' && <div className="mcq-modalOverlayBg" onClick={handleCloseModal}></div>} */}
            <div className={`mcq-slideModal-qs ${isQuestionsExpanded ? 'expanded' : 'collapsed'}`}>
                <div className="mcq-modalContentWrap">
                    <div className='mcq-ModalcloseBtn' onClick={toggleQuestionsModal}>
                        <div style={{ width: "80px", height: "6px", backgroundColor: "#D9DDE3", borderRadius: "10px" }}></div>
                    </div>
                    <div className="mcq-questions">
                        <div className="">
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                                <div className="progrsAtmptSec">
                                    <h4>{compltPercetg}%</h4>
                                    <p>completed</p>
                                </div>
                                <div className="mob-progress-bar-cntnr">
                                    <div className="mob-progress-bar">
                                        <div className="mob-progress-fill" style={{ width: compltPercetg + '%' }}></div>
                                    </div>
                                </div>
                                <div className="progrsAtmptSec">
                                    <p>Attempted</p>
                                    <h4>{attempted}/ {roundData?.questions?.length}</h4>
                                </div>
                            </div>
                            <p className='ptXt'>Questions</p>
                            <div className="question-grid">
                                {
                                    roundData?.questions?.map((ques, index) => {


                                        const isAnswered = ques?.options?.findIndex((i) => i?.iselected)
                                        return (
                                            <div key={index} className="d-flex justify-content-center pb-2">
                                                <div
                                                    className={`d-flex justify-content-center mcq-nums
                                    ${currentQuestionIndex === index ? 'active' : ''}
                                    ${isAnswered != -1 ? 'answered' : ''}`}
                                                    onClick={() => {
                                                        setCurrentQuestionIndex(index);
                                                        if (questionRefs.current[index]) {
                                                            questionRefs.current[index].scrollIntoView({ behavior: 'smooth', block: 'start' });
                                                        }
                                                        toggleQuestionsModal();
                                                    }}
                                                >
                                                    <a className={`mcq-nums-link text-center
                                        ${currentQuestionIndex === index ? 'active' : ''}
                                        ${isAnswered != -1 ? 'answered' : ''}`}>
                                                        {index + 1}
                                                    </a>
                                                </div>
                                            </div>
                                        )
                                    })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {showSubmitModal && (
                <div className="mcq-sbmt-modal-overlay">
                    <div className="mcq-sbmt-modal-content">
                        <div className="mcq-sbmt-close-btn">
                            <img src={WarningIcon} className="" alt="" style={{ width: "24px", height: "24px" }} />
                            <img src={closeIcon} className="clOse-IcOn" alt="" onClick={() => setShowSubmitModal(false)} />
                        </div>

                        <div className="mcq-sbmt-modal-header">

                            {/* {submitStatus === 'success' ? (
                                <h4>Quiz Submitted Successfully</h4>
                            ) : (
                                <h4>You haven’t completed the test yet !</h4>
                            )} */}
                            <h4>You haven’t completed the test yet</h4>
                        </div>
                        <div className="mcq-sccs-txt">



                            <p>{error}</p>

                        </div>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                            <div
                                className="mcq-sbmt-no-btn"
                                onClick={() => {
                                    saveData()
                                    setShowSubmitModal(false)
                                    // navigate("/LywoApplication3");
                                }}
                            >
                                <p>Yes</p>
                            </div>
                            <div
                                className="mcq-sbmt-exit-btn"
                                onClick={() => {
                                    setShowSubmitModal(false);
                                }}
                            >
                                <p>No</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}



            <div className="mobile-icons-mcq">
                <div className="mobile-icon-txt" onClick={() => handleIconClick('instructions')}>
                    <img src={instructionIcon} className="mobIcon" alt="Select language" />
                    <p>Instructions</p>
                </div>
                <div className="mobile-icon-txt" onClick={toggleQuestionsModal}>
                    <img src={questionIcon} className="mobIcon" alt="Edit Profile" />
                    <p>Questions</p>
                </div>
                <div className="mobile-icon-txt" onClick={editProfile}>
                    <img src={editProfileIcon} className="mobIcon" alt="Edit Profile" />
                    <p>Edit Profile</p>
                </div>
            </div>
        </>

    );
}
